import { normalizeRadians } from "@buildwithflux/shared";
import { Vector2 } from "three";
import { ZeroVector2 } from "../common";
export function positionShapeRelativeToRootLayout(polygon, position, rotation, scale) {
    const offset = new Vector2(Number.isNaN(position.x) ? 0 : position.x, Number.isNaN(position.y) ? 0 : position.y);
    const normX = normalizeRadians(rotation.x, true);
    const normY = normalizeRadians(rotation.y, true);
    const flipAroundXAxis = Math.abs(normX) > Math.PI / 2;
    const flipAroundYAxis = Math.abs(normY) > Math.PI / 2;
    return polygon
        .map((point) => new Vector2(point.x, point.y).rotateAround(ZeroVector2, rotation.z))
        .map((point) => point.set(point.x * (scale?.x ?? 1), point.y * (scale?.y ?? 1)))
        .map((point) => {
        if (flipAroundXAxis) {
            point.setY(-point.y);
        }
        if (flipAroundYAxis) {
            point.setX(-point.x);
        }
        return point.add(offset);
    });
}
//# sourceMappingURL=positionShapeRelativeToRootLayout.js.map